import './_media-blocks.scss';
import { responsive, debounce } from '../../../utilities';

$(() => {
    const $mediaBlocks = $('.media-blocks');
    if (!$mediaBlocks.length) {
        return;
    }
    function resize() {
        $mediaBlocks.each((_, mediaBlock) => {
            const $mediaBlock = $(mediaBlock);
            const $list = $mediaBlock.find('.media-blocks__listing');
            const $botMedia = $mediaBlock.find('.media-blocks__bot-img');
            const $botMediaVideo = $botMedia.find('.media-container');
            const $topImg = $mediaBlock.find('.media-blocks__top-img');
            const $topContent = $mediaBlock.find('.media-blocks__top-content');
            const $topContentCtr = $mediaBlock.find('.media-blocks__top-content-container');
            const $botContent = $mediaBlock.find('.media-blocks__bot-content');
            const $botContentCtr = $mediaBlock.find('.media-blocks__bot-content-container');
            const $botContentFootnote = $botContent.find('.media-blocks__img-label');
            const $botAccordion = $mediaBlock.find('.media-blocks__bot-accordion');

            const desktopContainerW = 1320;

            function initCSS() {
                $topContent.css('padding-bottom', '0');
                $topContent.css('margin-bottom', '0');
                $topImg.css('margin-bottom', '20px');
                $botContent.css('padding-top', '0');
                $botContentCtr.css('padding-top', '0');
                $botContentCtr.css('padding-left', '0');
                $topContent.css('padding-top', '0');
                $topContentCtr.css('padding-top', '0');
                $topContentCtr.css('padding-right', '0');
                $mediaBlock.find('.js-fit').css('width', 'auto');
                $mediaBlock.find('.js-fill').css('width', 'auto');
                $botAccordion.css('margin-top', '0');
                $botAccordion.css('width', 'auto');
            }

            function contentGap($el, naturalW, setRight) {
                const xGap = Number($el.attr('data-x-gap')) || 0;
                const yGap = Number($el.attr('data-y-gap')) || 0;
                const w = desktopContainerW - naturalW;
                const y = (yGap / w) * 100;
                const x = (xGap / w) * 100;
                $el.css('padding-top', `${y}%`);
                if (setRight) {
                    $el.css('padding-right', `${x}%`);
                } else {
                    $el.css('padding-left', `${x}%`);
                }
            }

            function botAccordionGap() {
                const h = $botMedia.outerHeight();
                const childH = $botMedia.children().outerHeight();
                const containerW = $list.width();
                const botAccordionMargin = ((h - childH) / containerW) * 100;
                $botAccordion.css('margin-top', `-${botAccordionMargin}%`);
            }

            function botMediaTranslateY() {
                const y = Number($botMedia.attr('data-translateY'));
                const marginPercent = (y / desktopContainerW) * 100;
                const topImgH = $topImg.find('.media-blocks__img').outerHeight();

                $topContent.css('padding-bottom', `${marginPercent}%`);
                $topContent.css('margin-bottom', `-${marginPercent}%`);
                $topImg.css('margin-bottom', `-${marginPercent}%`);
                const currY = ($list.outerWidth() * marginPercent) / 100;
                const topImgCtrH = $topImg.outerHeight();
                const gap = topImgCtrH - topImgH;
                const botContentT = ((currY - gap) / $list.outerWidth()) * 100;
                $botContent.css('padding-top', `${botContentT}%`);
            }

            // set width for js-fit and js-fill
            function blocksFlexWidth($ele, width, isBotMedia = false) {
                const $fitEl = $ele.closest('.js-fit');
                const position = $fitEl.attr('data-position');
                const $fillEl = $fitEl.siblings(`.js-fill[data-position=${position}]`);
                let fitW = width || $fitEl.width();

                fitW = (fitW / desktopContainerW) * 100;
                // console.log(fitW, $fillEl);
                $fitEl.css('width', `${fitW}%`);
                $fillEl.css('width', `${100 - fitW}%`);

                if (isBotMedia) {
                    $botAccordion.css('width', `${fitW}%`);
                    contentGap($botContentCtr, width);
                    contentGap($botContentFootnote, width);
                } else {
                    contentGap($topContentCtr, width, true);
                }
            }

            function loadImage($ele, isBotMedia, callback) {
                if ($ele.prop('complete')) {
                    // image is loaded from cache
                    blocksFlexWidth($ele, $ele.prop('naturalWidth'), isBotMedia);
                    if (callback) callback();
                } else {
                    $ele.on('load', () => {
                        blocksFlexWidth($ele, $ele.prop('naturalWidth'), isBotMedia);
                        if (callback) callback();
                    });
                }
            }

            function loadBotMedia($ele, flexWidth, callback) {
                const w = $ele.attr('data-width');
                const h = $ele.attr('data-height');
                const ratio = (h / w) * 100;
                $ele.css('padding-top', `${ratio}%`);

                if (flexWidth) {
                    blocksFlexWidth($ele, w, true);
                    callback();
                }
            }

            function loadedCallback() {
                botMediaTranslateY();
                botAccordionGap();
            }

            function init() {
                initCSS();
                responsive.breakAt({
                    callback: () => {
                        if ($botMediaVideo.length) {
                            loadBotMedia($botMediaVideo);
                        }
                    },
                    to: 'md',
                });
                responsive.breakAt({
                    callback: () => {
                        loadImage($topImg.find('.media-blocks__img'));
                        if (!$botMediaVideo.length) {
                            loadImage($botMedia.find('.media-blocks__img'), true, loadedCallback);
                        } else {
                            loadBotMedia($botMediaVideo, true, loadedCallback);
                        }
                    },
                    from: 'md',
                });
            }
            init();
        });
    }
    resize();
    window.addEventListener('resize', debounce(resize, 300));
});
